import http from '../http';

// 获取可冲减金额
const fetchReverseAmount = (params) => {
  return http({
    url: '/bills/items/reverse/amount',
    params,
  });
};

// 确认冲调
const confirmReverse = (data) => {
  return http({
    url: '/bill/reverse',
    method: 'POST',
    data,
  });
};

export { fetchReverseAmount, confirmReverse };
